import { BROADCAST_SET_SCENE_LAYOUT } from 'actions/Types';

export default scene => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_SCENE_LAYOUT,
      payload: scene
    };
    dispatch(action);
  };
};
